import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import '@fontsource-variable/montserrat';
import '@fontsource-variable/open-sans';
import './styles/globals.css';
import { Providers } from '@/components/providers';
import { router } from '@/app/router';
import { IS_DEMO } from '@/lib/env';

// Demo build only: `IS_DEMO` is a build-time constant, so none of this ships in the live bundle.
const DemoBanner = IS_DEMO ? lazy(() => import('@/demo/DemoBanner')) : null;
if (IS_DEMO) {
  document.documentElement.classList.add('demo-mode');
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      {DemoBanner && (
        <Suspense fallback={null}>
          <DemoBanner />
        </Suspense>
      )}
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
